import { toast } from "react-toastify";
import DefaultRepository from "../../Repository/DefaultRepository";
import {
  addItem,
  clearInventory,
  deleteItem,
  getItems,
  unSaleItems,
  updateItem,
} from "./itemsSlice";
import Repo from "../../Repository/Repo";
import { loadGoogleAnalytics } from "../../pages/analytics/analytics";

export const mutateItem = async (index, editItem, oldItem, dispatch) => {
  console.log('editItem', editItem)
  console.log('oldItem', oldItem)

  try {
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "updateItem",
        data: {
          item: {
            ...editItem,
            name: editItem.name,
            discount: editItem.discount,
            quantity: editItem.quantity ? editItem.quantity : oldItem.quantity,
            description: editItem.description,
            itemId: editItem.itemId,
            imgURL: editItem.imgURL,
            category: editItem.category,
            unit: editItem.unit,
            company_code: localStorage.getItem("companyCode"),
            minQuantity: editItem.minQuantity,
            price: editItem.price,
            costPrice: editItem.costPrice,
            itemCode: editItem.itemCode,
            dateOfPurchase: editItem.dateOfPurchase,
            vendor: editItem.vendor,
            whole_sale_price: editItem.whole_sale_price,
            companyPrice: editItem.companyPrice,
            sub_rack_code: editItem.sub_rack_code,
            rack_code: editItem.rack_code,
            weight: editItem.weight,
            weightType: editItem.weightType,
            shop_stock: editItem.shop_stock,
            barCode: editItem.barCode,
            shop_code: editItem.shop_code,
            boxes: editItem.boxes,
            packing: editItem.packing,
            batchNumber: editItem.batchNumber,
            expiryDate: editItem.expiryDate,
            imgUrl: editItem.imgUrl || "",
            steelWeight: (editItem?.steelWeightTotal) 

          },
          action: "Updated",
          user: localStorage.getItem("token"),
        },
      },
    });
    if (data.response.data.item == "") {
      dispatch(clearInventory());
    } else if (data.response.data.item) {
      toast.configure();
      toast.success("Item updated Successfully");
      dispatch(getItems());
    }
  } catch (err) {
    console.log(err);
  }
};

export const remItem = async (id, index, item) => {
  try {
    await DefaultRepository.defaultModel({
      request: {
        method: "deleteItems",
        data: {
          _id: id,
          user: localStorage.getItem("token"),
          company_code: localStorage.getItem("companyCode"),
          action: "Removed",
        },
      },
    });
    toast.configure();
    toast.success("Item Deleted");
  } catch (err) {
    toast.configure();
    toast.error("Not Deleted");
    dispatch(addItem({ index: index, item: item }));
  }
};

export const saveItem = async (
  item,
  dispatch,
  piecesPerBox,
  box,
  pricePerPiece,
  status
) => {
  console.log("priceperpiece", pricePerPiece);
  console.log("statusss", status);
  console.log("itemmmmm", item);
  if(item.costPrice !== "") {
  item.costPrice = Number(item?.costPrice)
  }
  if(item.salePrice !== "") {
    item.salePrice = Number(item?.salePrice)

  }
  item.price = Number(item?.price)
  item.quantity = Number(item?.quantity)
  item.minquantity = Number(item?.minquantity)
  if(item.salePrice !== "") {
    item.salePrice = Number(item?.salePrice)

  }
   if(item.salePrice == null ||  item.salePrice == undefined || isNaN(item.salePrice)) {
    delete item.salePrice
  }
  console.log("Keys after before:", item.steelWeightKg)
  if (item.steelWeightKg == null || item.steelWeightKg == undefined || isNaN(item.steelWeightKg)) {
    delete item.steelWeightKg;
  }
  
  console.log("Keys after delete:", Object.keys(item))

  if(item.steelWeightTotal == null ||  item.steelWeightTotal  == undefined || isNaN(item.steelWeightTotal)) {
    delete item.steelWeightTotal
  }


  // item.totalBoxes = Number(item.quantity) / Number(piecesPerBox);
  console.log("item.totalBoxes",item.quantity)
  console.log("item.totalBoxes",item.piecesPerBox)

    console.log("item.totalBoxes",item.totalBoxes)

  if(item.totalBoxes == "" || item.totalBoxes ) {
    item.totalBoxes = Number(item?.totalBoxes)

  }
  


  const trackingId = "G-9JX2HR95FS";
  let requestData;
  if (box == true) {
    const totalPieces = Number(item.quantity * piecesPerBox);

    requestData = {
      // box:item.box,
      // piecesPerBox:item.piecesPerBox,

      // item: { ...item, piecesPerBox: Number(piecesPerBox), box, totalPieces, pricePerPiece:Number(pricePerPiece) },
      item: { ...item, piecesPerBox: Number(piecesPerBox), box, pricePerPiece:Number(pricePerPiece) },

      company_code: item.companyCode,
      action: "Created",
      user: localStorage.getItem("token"),
    };
  } else {
    requestData = {
      item: item,
      company_code: item.companyCode,
      action: "Created",
      user: localStorage.getItem("token"),
    };
  }

  let { data } = await DefaultRepository.defaultModel({
    request: {
      method: "saveItem",
      data: {

        ...requestData,
      },
    },
  });
  if (data.response.data.item) {
    toast.configure();
    toast.success("Item Added Successfully");
    console.log('temmmmmmmmmmm')
    // loadGoogleAnalytics(trackingId);
    // if (status === "paid" && typeof gtag === "function") {
    //   gtag("event", "add_item", {
    //     event_category: "Item Management",
    //     event_label: item.itemName || "Unnamed Item",
    //     value: pricePerPiece, // Optional: Track value of the item
    //   });
    //   console.log("Google Analytics: Item added event sent");
    // }
    dispatch(getItems());

  } else {
    dispatch(deleteItem({ index: 0 }));
    toast.configure();
    toast.error("Item Not Added");
  }
};
export const saveIncentive = async (props) => {
  try {
    let { data } = await Repo.incentive({
      request: {
        method: "saveIncentive",
        data: {
          ...props,
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    return data;
  } catch (err) {
    console.log(err);
  }
};
export const updateItems = async (items, dispatch, oldItems, type = "") => {
  let { data } = await DefaultRepository.defaultModel({
    request: {
      method: "updateItem",
      data: {
        items: items,
        action: type == "Transfer" ? "Transfer" : "Sold",
        user: localStorage.getItem("token"),
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    console.log("statuscode");
    dispatch(getItems());
  } else {
    dispatch(unSaleItems(items));
    console.log("oldItems", oldItems);
  }
};
export const updateItemsDisc = async (items, dispatch, oldItems) => {
  try {
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "updateItem",
        data: {
          items: items,
          action: "Update",
          user: localStorage.getItem("token"),
        },
      },
    });
    if (data.response.status.statusCode == 200) {
    } else {
      dispatch(clearInventory());
    }
  } catch (err) {
    console.log(err);
    toast.configure();
    toast.error("Error");
    dispatch(clearInventory());
  }
};

export const removeBulk = async (items, dispatch) => {
  let successCount = 0;
  try {
    items.forEach(async (item) => {
      let { data } = await DefaultRepository.defaultModel({
        request: {
          method: "deleteItems",
          data: {
            _id: item._id,
            user: localStorage.getItem("token"),
            company_code: localStorage.getItem("companyCode"),
            action: "Removed",
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        successCount++; 
        if(successCount <= 1) {
          toast.configure();
          toast.success("Items Deleted");
        }
     
        dispatch(getItems());
      } else {
        dispatch(clearInventory());
      }
    });
  } catch (err) {
    console.log("err", err);
    toast.configure();
    toast.error("Error");
    dispatch(clearInventory());
  }
};
